var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-carousel',{attrs:{"height":"250"}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":item.src,"reverse-transition":"fade-transition","transition":"fade-transition","progress":true}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }